var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"nav nav-pills content-nav"},[_vm._l((_vm.visibleTabs),function(tab){return _c('li',{key:tab.key,class:_vm.value === tab.key && 'active',on:{"click":function($event){return _vm.$emit('input', tab.key)}}},[_c('a',{attrs:{"data-toggle":"tab"}},[_vm._v(_vm._s(tab.label))])])}),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }